export enum StandardTrainingCategoryTypeModel {
  PrivateInsurance,
  CorporateInsurance
}